<template>
    <div class="min-h-screen bg-gray-100 pb-24">
        <div class="max-w-[600px] mx-auto">

            <!-- Header -->
            <div class="bg-white sticky top-0 z-10 shadow-sm">
                <div class="flex items-center gap-3 p-4">
                    <button @click="$router.back()" class="p-1">
                        <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                            </path>
                        </svg>
                    </button>
                    <h1 class="text-lg font-bold text-gray-800 flex-1">İlan Detayı</h1>
                    <button class="p-1">
                        <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z">
                            </path>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Resim Galerisi -->
            <div class="relative bg-black">
                <div class="h-80 overflow-x-auto flex snap-mandatory snap-x">
                    <div v-for="(img, index) in listing.images" :key="index" class="w-full flex-shrink-0 snap-center">
                        <div
                            class="h-80 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 flex items-center justify-center">
                            <span class="text-6xl">{{ img.icon || '📦' }}</span>
                        </div>
                    </div>
                </div>
                <div class="absolute bottom-2 right-2 bg-black/50 text-white text-xs px-2 py-1 rounded-full">
                    {{ listing.images.length }} fotoğraf
                </div>
            </div>

            <!-- İlan Başlık ve Fiyat -->
            <div class="bg-white p-4">
                <div class="flex justify-between items-start">
                    <div>
                        <h1 class="text-xl font-bold text-gray-800">{{ listing.title }}</h1>
                        <p class="text-sm text-gray-500 mt-1">{{ listing.category }} • {{ listing.location }}</p>
                    </div>
                    <div class="text-right">
                        <div class="text-2xl font-bold text-takas-sari">{{ listing.price || 'Takaslık' }}</div>
                        <p class="text-xs text-gray-400">{{ listing.tradeValue }}</p>
                    </div>
                </div>
            </div>

            <!-- İlan Metrikleri (Teklif Sayısı dahil) -->
            <div class="bg-white mt-2 p-4">
                <div class="flex justify-around">
                    <div class="text-center">
                        <div class="flex items-center gap-1 justify-center">
                            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                                </path>
                            </svg>
                            <span class="text-sm text-gray-600">{{ listing.views }}</span>
                        </div>
                        <p class="text-xs text-gray-400">Görüntülenme</p>
                    </div>
                    <div class="text-center">
                        <div class="flex items-center gap-1 justify-center">
                            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z">
                                </path>
                            </svg>
                            <span class="text-sm text-gray-600">{{ listing.favorites }}</span>
                        </div>
                        <p class="text-xs text-gray-400">Favori</p>
                    </div>
                    <div class="text-center">
                        <div class="flex items-center gap-1 justify-center">
                            <svg class="w-5 h-5 text-takas-sari" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.8-3.6A7.94 7.94 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z">
                                </path>
                            </svg>
                            <span class="text-sm font-semibold text-takas-sari">{{ listing.offerCount }}</span>
                        </div>
                        <p class="text-xs text-gray-400">Takas Teklifi</p>
                    </div>
                </div>
            </div>

            <!-- Satıcı Profili -->
            <div class="bg-white mt-2 p-4">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                        <div
                            class="w-14 h-14 rounded-full bg-gradient-to-br from-takas-sari to-yellow-400 flex items-center justify-center">
                            <span class="text-2xl font-bold text-takas-koyu">{{ sellerInitial }}</span>
                        </div>
                        <div>
                            <div class="flex items-center gap-2">
                                <h3 class="font-semibold text-gray-800">{{ seller.name }}</h3>
                                <span
                                    class="bg-green-100 text-green-600 text-xs px-2 py-0.5 rounded-full">Doğrulanmış</span>
                            </div>
                            <div class="flex items-center gap-3 mt-1">
                                <div class="flex items-center gap-1">
                                    <svg class="w-4 h-4 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                                        <path
                                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                    </svg>
                                    <span class="text-sm font-medium">{{ seller.rating }}</span>
                                    <span class="text-xs text-gray-400">({{ seller.totalRatings }})</span>
                                </div>
                                <span class="text-xs text-gray-400">•</span>
                                <span class="text-xs text-gray-500">{{ seller.successTrades }} başarılı takas</span>
                            </div>
                            <p class="text-xs text-gray-400 mt-1">Üye: {{ seller.joinDate }}</p>
                        </div>
                    </div>
                    <button @click="goToProfile"
                        class="px-4 py-2 border border-takas-sari text-takas-sari rounded-lg text-sm font-medium">
                        Profil
                    </button>
                </div>
            </div>

            <!-- İlan Açıklaması -->
            <div class="bg-white mt-2 p-4">
                <h3 class="font-semibold text-gray-800 mb-2">Açıklama</h3>
                <p class="text-gray-600 text-sm leading-relaxed">{{ listing.description }}</p>

                <div class="mt-3 flex flex-wrap gap-2">
                    <span v-for="tag in listing.tags" :key="tag"
                        class="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                        #{{ tag }}
                    </span>
                </div>
            </div>

            <!-- İlan Detayları -->
            <div class="bg-white mt-2 p-4">
                <h3 class="font-semibold text-gray-800 mb-3">İlan Detayları</h3>
                <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                        <span class="text-gray-500">Durum</span>
                        <span :class="listing.condition === 'Yeni' ? 'text-green-600' : 'text-gray-600'"
                            class="font-medium">
                            {{ listing.condition }}
                        </span>
                    </div>
                    <div class="flex justify-between text-sm">
                        <span class="text-gray-500">Takas İstediği</span>
                        <span class="text-gray-800">{{ listing.wantsToTrade }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                        <span class="text-gray-500">İlan Tarihi</span>
                        <span class="text-gray-800">{{ listing.createdAt }}</span>
                    </div>
                </div>
            </div>

            <!-- Alt Aksiyon Butonları (TabBar'ın üstünde, ayrı duran) -->
            <div class="bg-white border-t border-gray-200 p-4 shadow-lg mt-4">
                <div class="flex gap-3 max-w-[600px] mx-auto">
                    <button @click="goToOfferPage"
                        class="flex-1 bg-takas-sari text-takas-koyu font-bold py-3 rounded-xl shadow-lg">
                        Takas Teklifi Yap ({{ listing.offerCount }})
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListingDetail',
    data() {
        return {
            listingId: null,
            listing: {
                id: 1,
                title: 'iPhone 14 Pro',
                category: 'Telefon',
                location: 'İstanbul',
                price: 'Takaslık',
                tradeValue: 'Değer: 25.000 TL',
                description: 'Kutusu ve tüm aksesuarlarıyla birlikte. Hiçbir çizik yok. Garantisi devam ediyor. Apple Türkiye garantilidir. Sadece temiz cihazlarla takas düşünülür.',
                condition: 'Yeni gibi',
                wantsToTrade: 'iPhone 15 veya Samsung S23 Ultra',
                views: 245,
                favorites: 34,
                offerCount: 12,
                createdAt: '15 Ocak 2024',
                tags: ['iphone', 'apple', 'telefon', 'takas'],
                images: [{ icon: '📱' }, { icon: '📱' }, { icon: '📱' }]
            },
            seller: {
                name: 'Ahmet Yılmaz',
                rating: 4.9,
                totalRatings: 128,
                successTrades: 67,
                joinDate: 'Aralık 2022'
            }
        }
    },
    computed: {
        sellerInitial() {
            return this.seller.name.charAt(0).toUpperCase()
        }
    },
    created() {
        this.listingId = this.$route.params.id
    },
    methods: {
        goToProfile() {
            this.$router.push('/profile/1')
        },
        startChat() {
            this.$router.push('/chat/1')
        },
        goToOfferPage() {
            this.$router.push(`/offer/${this.listingId}`)
        }
    }
}
</script>